import React from "react";
import {
  Dialog,
  DialogContent,
  Skeleton,
  Box,
  Stack,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

const AddressFormSkeleton = () => {
  return (
    <Grid container spacing={3} sx={{ p: 2 }}>
      {/* Left Side Form Skeleton */}
      <Grid size={6}>
        <Grid container spacing={4}>
          {[...Array(3)].map((_, index) => (
            <Grid size={index < 2 ? 6 : 12} key={index}>
              <Skeleton variant="rounded" height={50} />
            </Grid>
          ))}
          <Grid size={12}>
            <Skeleton variant="rounded" height={150} />
          </Grid>
          <Grid size={12}>
            <Stack direction="row" spacing={2}>
              {[...Array(3)].map((_, i) => (
                <Skeleton key={i} variant="rounded" width={80} height={32} />
              ))}
            </Stack>
          </Grid>
          <Grid size={12}>
            <Skeleton variant="rounded" height={50} />
          </Grid>
        </Grid>
      </Grid>

      {/* Right Side Map + Buttons Skeleton */}
      <Grid size={6}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={400}
          sx={{ borderRadius: 2 }}
        />
        <Skeleton variant="text" width="95%" height={20} sx={{ mt: 2 }} />
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2, gap: 2 }}>
          <Skeleton variant="rounded" width="45%" height={36} />
          <Skeleton variant="rounded" width="45%" height={36} />
        </Box>
      </Grid>
    </Grid>
  );
};

export default AddressFormSkeleton;
